import { IAbsenceWarningRepository } from 'shared/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisAbsenceWarningRepository from './implementations/VectisAbsenceWarningRepository';

let instance: IAbsenceWarningRepository | null;

export default function makeAbsenceWarningRepository() {
  if (!instance) {
    const provider = makeHTTPProvider();

    instance = new VectisAbsenceWarningRepository(provider);
  }

  return instance;
}
